<template>
  <div class="w-full h-full bg-[#151A1F]">
    <div class="w-full h-full rounded-t-[12px] mb-32">
      <div
        class="text-center bg-[#2C7952]/40 h-[44px] flex items-center justify-center relative rounded-t-[12px]"
      >
        <div class="text-lg text-white !text-[16px]">{{ $t('Deposit.popPage.Title') }}</div>
        <img
          class="w-[24px] h-[24px] absolute right-5 opacity-45"
          :src="closeIcon"
          @click="handleCloseUUPayForm"
          alt="close"
        />
      </div>
      <div class="w-[90%] m-auto">
        <IconFormInput
          :label="$t('Deposit.popPage.YourName')"
          :placeholder="$t('Deposit.popPage.EnterYourName')"
          v-model="uuPayForm.payeeName"
          :icon="payment_name"
          :errorMessage="uuPayFormErrors.payeeName?.message"
          @input="(e) => validateUUPayForm(e, 'payeeName')"
        />

        <IconFormInput
          :label="$t('Deposit.popPage.YourCPF')"
          :placeholder="$t('Deposit.popPage.EnterYourCPF')"
          v-model="uuPayForm.payeeCpf"
          :icon="payment_account"
          :errorMessage="uuPayFormErrors.payeeCpf?.message"
          @input="(e) => validateUUPayForm(e, 'payeeCpf')"
        />

        <div
          class="flex justify-center gap-2 my-8 border-[1px] border-solid border-white/75 px-4 py-2 rounded-lg"
        >
          <img :src="important" class="w-[18px] h-[18px]" alt="important" />
          <div class="text-[13px] text-white/50 break-all">
            {{ $t('Deposit.popPage.RuleTips') }}
          </div>
        </div>
        <div class="flex justify-between mt-6">
          <van-button class="!mr-6 primaryBtn_transparent" @click="handleCloseUUPayForm">
            {{ t('Common.Cancel') }}
          </van-button>
          <van-button :loading="loading" class="primaryBtn" @click="submitUUpayForm">
            {{ t('Common.Confirm') }}
          </van-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import closeIcon from "@/themes/theme_a/views/Deposito/images/closeIcon.png";
import payment_name from "@/themes/theme_a/views/Deposito/images/payment_name.png";
import payment_account from "@/themes/theme_a/views/Deposito/images/payment_account.png";
import important from "@/themes/theme_a/views/Deposito/images/important.png";
import IconFormInput from "@/themes/theme_a/components/IconFormInput/index.vue";
import { z } from "zod";
import debounce from "lodash-es/debounce";
import compose from "koa-compose";
import i18n from "@/i18n";
const t = i18n.global.t;
const uuPaySchema = z
  .object({
    payeeName: z.string().min(3, { message: t('Deposit.popPage.uuPaySchema.payeeName') }),
    payeeCpf: z.string().min(11, { message: t('Deposit.popPage.uuPaySchema.payeeCpf') }),
  })
  .partial();
const emit = defineEmits(["closeModal"]);
const props = defineProps<{
  uuPayForm: any;
  _createOrder: any;
}>();
const uuPayForm = ref(props.uuPayForm);
const uuPayFormErrors = ref<any>({});
const loading = ref(false);
const handleCloseUUPayForm = () => {
  emit("closeModal");
};

onMounted(() => {});
// 验证表单
const validateUUPayForm = (e, key) => {
  const validateResult = uuPaySchema.safeParse({ [key]: e.target.value });
  if (validateResult.success) {
    uuPayFormErrors.value = {
      ...uuPayFormErrors.value,
      [key]: null,
    };
  } else {
    uuPayFormErrors.value = Object.assign(
      {},
      uuPayFormErrors.value,
      validateResult.error.issues.reduce((pre, next) => {
        pre[next.path[0]] = next;
        return pre;
      }, {})
    );
  }

  console.log(uuPayFormErrors.value);
};
// 提交表单
const submitUUpayForm = debounce(async () => {
  loading.value = true;
  if (!canUUPaySubmit.value) return;
  const composeMiddleWare = compose([savePaymentInfoMD, createOrderMD]);
  const ctx = {
    savePaymentInfoFlag: false,
    createOrderFlag: false,
  };
  await composeMiddleWare(ctx);
  if (Object.values(ctx).every(Boolean)) {
    loading.value = false;
    handleCloseUUPayForm();
    uuPayForm.value = {
      payeeName: "",
      payeeCpf: "",
    };
    uuPayFormErrors.value = {};
  }
  loading.value = false;
}, 500);

const savePaymentInfoMD = async (ctx, next) => {
  ctx.savePaymentInfoFlag = true;
  await next();
};

const createOrderMD = async (ctx, next) => {
  const result = await props._createOrder(uuPayForm.value);
  if (result.code === 1) {
    ctx.createOrderFlag = true;
    await next();
  } else {
    ctx.createOrderFlag = false;
  }
};
const canUUPaySubmit = computed(() => {
  if (!uuPayForm.value.payeeCpf || !uuPayForm.value.payeeName) return false;
  if (!Object.values(uuPayFormErrors.value).filter(Boolean).length) {
    return true;
  }
  return false;
});
</script>
